document.addEventListener("DOMContentLoaded", () => {
    var ccidval = document.getElementById('ccid');
    
    if(ccidval){
        var ccid = ccidval.value;
        document.querySelectorAll('select[name="options[Elige tu centro]"]').forEach((select) => {
            console.log(select);
            setTimeout(function() { 
            const defaultOption = select.querySelector(`option[data-sku="${ccid}"]`);
            if (defaultOption) {
                select.value = defaultOption.value;

                // Native change event
                select.dispatchEvent(new Event('change', { bubbles: true }));

                // If your theme uses jQuery listeners
                $(select).trigger('change');

                $('button[name="add"], button#res_tarde_button').removeClass('disabled_button');
                $('#msg_centro').addClass('hide_me');
            }
            }, 1000);
        });
    }
});
  var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
  };
$(document).ready(function(){
    $('select[name="options[Elige tu centro]"]').on('change', function(){
        $('button[name="add"], button#res_tarde_button').removeClass('disabled_button');
        $('div#msg_centro').addClass('hide_me');
    });

    var is_app = getUrlParameter('is_app');
    console.log("is app "+is_app);
    if(is_app == 'true'){
        $('.header-promo, .header, .footer').addClass('hideme');
    }
    var n = 1;
    setTimeout(function() { 
        console.log('custom.js');
        $('input[name="sesiones"]').siblings('label').on('click',function(){
            var sessions = $(this).siblings('input').val();
            //$('input[name="quantity"]').val(sessions);
        })
        $( "div.id_number input" ).attr("pattern", '^[0-9]{8}[A-Z]$').prop('required', true);

        var pathname = window.location.href;
        console.log(pathname);
        $( "div.formurl").find('input').attr('data-default-input-value',pathname);
        $( "div.formurl").find('input').attr('value',pathname);
        $( "div.id_number input" ).attr("pattern", '^[0-9]{8}[A-Z]$').prop('required', true);
        
        $('form.g-container').on('click','button.material_filled-button', function(){
            var allAreFilled = true;
            var isClinicForm = $('div.center').find('select').val();
            console.log(isClinicForm);
            
            if(isClinicForm > 0 && n == 1){
                n++;
                document.addEventListener('globo.formbuilder.form.submitted', e => {
                const form = e.detail.form;
                    var alldata = {};
                    $.each($('form.g-container').serializeArray(), function(_, field) {
                        var input = $('[name="' + field.name + '"]');
                        var label = $('label[for="' + input.attr('id') + '"]').text().trim();
                        if(label != ''){
                            if(label.includes('promociones') || label.includes('promotional')){
                                alldata['ClientEnableRGPD'] = field.value;
                            }else if(label.includes('política de privacidad') || label.includes('privacy policy')){
                                alldata['ClientEnableGeneralCondition'] = field.value;
                            }else{
                                alldata[label] = field.value;
                            }
                            
                        }
                    });
                    var formData = {    
                        "nombre": $('div.name').find('input').val(),    
                        "apellidos": $('div.surname').find('input').val(),      
                        "telefono": $('div.telephone').find('input').val(),    
                        "email": $('div.main-email').find('input').val(),    
                        "clinic_id": $('div.center').find('select').val(),    
                        "form_name": $('div.formname').find('input').attr('data-default-input-value'),    
                        "source_url": pathname,
                        "form_data": alldata
                    };
                    var formid = $('div.formname').find('input').attr('data-default-input-value');
                    
                    var settings = {
                        url: "https://grupostopapi.w4p.co.uk/api/v1/forms/submit",
                        method: "POST",
                        contentType: 'application/json',
                        crossDomain: true,
                        timeout: 0,
                        data: JSON.stringify(formData),
                    };
                    $.ajax(settings)
                    .done(function() {
                        console.log('shopify app form done');
                        if(formid === 'ZZ_DL FORMULARIO FEEBBO'){
                            console.log(formid);
                                var img = document.createElement('img');
                                img.width = 1;
                                img.height = 1;
                                img.style.display = 'none';
                                img.src = 'https://feebbo.uinterbox.com/tracking/cnv?org=3647&evt=8238';
                                document.body.appendChild(img);
                        }
                    })
                    .fail(function(xhr, status, error) {
                        console.log(xhr);
                        console.log('Status:', status);
                        console.log('Error:', error);
                        console.log('Response:', xhr.responseText);
                        console.log('HTTP Code:', xhr.status);
                    })
                    .always(function() {
                    console.log(JSON.stringify(formData));
                    });
                });

                // $('form.g-container').find('[required]').each(function() {
                //     if (!allAreFilled) {
                //     return;
                //     }
                //     if (!this.value) {
                //     allAreFilled = false;
                //     this.setCustomValidity('This field is required');
                //     this.reportValidity();
                //     } else {
                //     this.setCustomValidity('');
                //     }
                // });
            
                // if (!allAreFilled) {
                // console.log('form blank');               
                // }else{
                //     var alldata = {};
                //     $.each($('form.g-container').serializeArray(), function(_, field) {
                //         var input = $('[name="' + field.name + '"]');
                //         var label = $('label[for="' + input.attr('id') + '"]').text().trim();
                //         if(label != ''){
                //             if(label.includes('promociones') || label.includes('promotional')){
                //                 alldata['ClientEnableRGPD'] = field.value;
                //             }else if(label.includes('política de privacidad') || label.includes('privacy policy')){
                //                 alldata['ClientEnableGeneralCondition'] = field.value;
                //             }else{
                //                 alldata[label] = field.value;
                //             }
                            
                //         }
                //     });
                //     var formData = {    
                //         "nombre": $('div.name').find('input').val(),    
                //         "apellidos": $('div.surname').find('input').val(),      
                //         "telefono": $('div.telephone').find('input').val(),    
                //         "email": $('div.main-email').find('input').val(),    
                //         "clinic_id": $('div.center').find('select').val(),    
                //         "form_name": $('div.formname').find('input').attr('data-default-input-value'),    
                //         "source_url": pathname,
                //         "form_data": alldata
                //     };
                //     console.log(formData);
                //     var settings = {
                //         url: "https://grupostopapi.w4p.co.uk/api/v1/forms/submit",
                //         method: "POST",
                //         contentType: 'application/json',
                //         crossDomain: true,
                //         timeout: 0,
                //         data: JSON.stringify(formData),
                //     };
                //     $.ajax(settings)
                //     .done(function() {
                //         console.log('shopify app form done');
                //     })
                //     .fail(function(xhr, status, error) {
                //         console.log(xhr);
                //         console.log('Status:', status);
                //         console.log('Error:', error);
                //         console.log('Response:', xhr.responseText);
                //         console.log('HTTP Code:', xhr.status);
                //     })
                //     .always(function() {
                //     console.log(JSON.stringify(formData));
                //     });
                // }
            }

        });
        var clinicname = $('input[name="clinicId"]').val();
        //console.log($('input[value="Barcelona - Centro Paseo San Juan"]').attr('gpo-data-variant-id'));
        //$('input[value="'+clinicname+'"]').parent().trigger('click');
        $('input[value="'+clinicname+'"]').attr('previous-value', 'checked');
   }, 4000);

   $('.collection-clinic-contact-faq__btn--cta[href*="#"]:not([href="#"])').on('click', function(e) {
    e.preventDefault();
    var target = $(this.hash);
    $('html,body').stop().animate({
        scrollTop: target.offset().top - 200
    }, 'linear');   
   });
});
